module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/TZ-b4a3602cc8ba247791239ae99693ddfa.png";